import React from 'react';
import { CoreLink } from '@uncinc/react-drupal-core';
import { Image } from '@uncinc/uncinc-react-kitchen-sink';
import Truncate from 'react-truncate';
import PropTypes from 'prop-types';

import './style.scss';
import { TOOLKIT_CARD_VARIANT_DOCUMENT } from '../../../config/constants';

const PrevNextCard = ({
  left = false,
  showLabel = false,
  label = '',
  title = '',
  body = '',
  path = '',
  icon = '',
  svg = '',
  toolkitVariant = '',
  forToolkit = false,
  forHomepage = false,
}) => {
  return (
    <CoreLink
      className={`PrevNext__card ${left ? 'left' : 'right'} ${forToolkit ? 'PrevNext__card__toolkit' : ''}`}
      to={path}
      target={toolkitVariant === TOOLKIT_CARD_VARIANT_DOCUMENT ? '_blank' : ''}
    >
      {icon && (
        <div className="PrevNext__card__icon">
          <i className={`icon icon-${icon}`} />
        </div>
      )}
      {svg && (
        <div className="PrevNext__card__image">
          <Image src={svg} alt={title} />
        </div>
      )}

      <div className="PrevNext__card__content">
        <div className="PrevNext__cardTopBar">
          {!forHomepage && label && showLabel && (
            <div className="PrevNext__cardTopBar__label PrevNext__cardLabel">
              {label}
            </div>
          )}
        </div>
        <div className="PrevNext__cardTitle">{title}</div>
        {body && (
          <div className="PrevNext__cardBody">
            <Truncate lines={2} ellipsis="...">
              {body}
            </Truncate>
          </div>
        )}
      </div>

      {forToolkit
        ? (
          <div className="PrevNext__card__linkIcon">
            {toolkitVariant === 'external' && <div className="icon icon-external-link" />}
            {toolkitVariant === 'internal' && <div className="icon icon-arrow-right" />}
            {toolkitVariant === 'document' && <div className="icon icon-download" />}
          </div>
        )
        : (
          <div className="PrevNext__card__linkIcon">
            <div className="icon icon-arrow-right" />
          </div>
        )}
    </CoreLink>
  );
};

PrevNextCard.defaultProps = {
  left: false,
  showLabel: false,
  label: '',
  title: '',
  body: '',
  path: '',
  icon: '',
  svg: '',
  toolkitVariant: '',
  forToolkit: false,
  forHomepage: false,
};

PrevNextCard.propTypes = {
  left: PropTypes.bool,
  showLabel: PropTypes.bool,
  label: PropTypes.string,
  title: PropTypes.string,
  body: PropTypes.string,
  path: PropTypes.string,
  icon: PropTypes.string,
  svg: PropTypes.string,
  toolkitVariant: PropTypes.string,
  forToolkit: PropTypes.bool,
  forHomepage: PropTypes.bool,
};

export default PrevNextCard;
